export default __webpack_public_path__ + "static/media/IMG_5069.05ec727c.png";